// Meeting → Share, route side. A colleague WITHOUT Meetly may still open the
// list of meetings shared with them and a shared meeting itself, so the panel
// gate lets these paths through — the API decides what they can actually read
// (a meeting that is not theirs and not shared with them is a 404).
export const MEETLY_SHARED_PATH = '/meetly/shared';

export const isSharedMeetlyPath = (pathname: string): boolean =>
  pathname === MEETLY_SHARED_PATH || /^\/meetly\/meetings\/[^/]+\/?$/.test(pathname);

/**
 * Where the Meeting menu entry points: the workspace for a Meetly user, the
 * shared list for a colleague who only has meetings shared with them, or
 * nowhere (null — hide it).
 */
export const meetlyNavHref = (meetlyVisible: boolean, sharedCount: number): string | null =>
  meetlyVisible ? '/meetly' : sharedCount > 0 ? MEETLY_SHARED_PATH : null;
